var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02325 13C5.02325 12.2036 5.15553 11.44 5.39162 10.7238L1.25916 7.56812C0.453767 9.20337 0 11.046 0 13C0 14.9524 0.453208 16.7939 1.25749 18.428L5.38771 15.2662C5.15385 14.5533 5.02325 13.7926 5.02325 13Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2777 5.7544C14.0079 5.7544 15.5707 6.36748 16.7986 7.37071L20.3707 3.80369C18.194 1.90871 15.4033 0.738281 12.2777 0.738281C7.42524 0.738281 3.25483 3.51331 1.25781 7.56801L5.39027 10.7237C6.34245 7.83331 9.05668 5.7544 12.2777 5.7544Z",
    fill: "#EB4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2777 20.2454C9.05668 20.2454 6.34245 18.1665 5.39027 15.2761L1.25781 18.4313C3.25483 22.4865 7.42524 25.2616 12.2777 25.2616C15.2727 25.2616 18.132 24.1981 20.2781 22.2056L16.3555 19.1731C15.2487 19.8703 13.855 20.2454 12.2777 20.2454Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9983 12.9999C23.9983 12.2753 23.8866 11.4951 23.7192 10.7705H12.2773V15.508H18.8634C18.5341 17.1231 17.6377 18.3649 16.3551 19.1731L20.2777 22.2056C22.532 20.1133 23.9983 16.9966 23.9983 12.9999Z",
    fill: "#4285F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.040287a73b7545810f04ee9d0c46fafa.svg";
export { ForwardRef as ReactComponent };